import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import VerticalNavBar from '../components/Navbar/VerticalNavBar'
import ResultTable from '../components/Table/ResultTable'

const TablePage = () => {

  return (<>
  <Navbar/>
      <div className='flex'>
        <div className='aboslute w-[200px] h-[100vh]'>
            <VerticalNavBar/>
        </div>
        <div className='flex flex-grow-1 p-5'>
            <ResultTable/>
        </div>
        <div>

        </div>
      </div>

  <Footer/>
  </>

  )
}

export default TablePage